import Welcome from '@pages/welcome/welcome';
export default Welcome;
